/**
 * Índice de traducciones para EmptyView
 */

import { emptyViewTranslationsEs } from './es';
import { emptyViewTranslationsEn } from './en';

export interface EmptyViewTranslations {
  noResults: {
    title: string;
    description: string;
  };
  emptyState: {
    title: string;
    description: string;
  };
}

export const emptyViewTranslations: Record<string, EmptyViewTranslations> = {
  es: emptyViewTranslationsEs,
  en: emptyViewTranslationsEn,
};

/**
 * Hook para obtener traducciones de EmptyView
 */
export const useEmptyViewTranslations = (locale: string = 'es') => {
  return emptyViewTranslations[locale] || emptyViewTranslations.es;
};

// Exportar traducciones individuales
export { emptyViewTranslationsEs } from './es';
export { emptyViewTranslationsEn } from './en';
